export type PropsMedicao = {
  resp_calibra: string
  precisaocalibra: string
  chapa: string
  bitola: string
  largurachapa: string
  tipoesteira: string
  alinhamentoesteira: string
  corrente: string
  nivelamento: string
  pqueda: string
  desgastepalheta: string
  condicoesdiscos: string
  condicoesesteira: string
  rpmdisco: number
  vento: string
  taxafixa: string
  caixa: string
}

export function tratarDadosFiltrar(dados) {
  const dadosTratados = dados
    ?.slice(0, 44)
    ?.map((item) => {
      const novoItem = { ...item }
      for (let i = 1; i <= 62; i++) {
        const key = `r${i}`
        if (novoItem[key] == null) {
          novoItem[key] = '0'
        }
      }

      return novoItem
    })
    .filter((item) => {
      for (let i = 1; i <= 62; i++) {
        const key = `r${i}`
        if (Number(item[key]) !== 0) {
          return true
        }
      }
      return false
    })

  return processarArray(dadosTratados)
}

export const intercalarSentidos = (array) => {
  const grupo11 = array?.filter((item) => item.sentido === 11)
  const grupo12 = array?.filter((item) => item.sentido === 12)

  const resultado = []
  const maxLength = Math?.max(grupo11?.length, grupo12?.length)

  for (let i = 0; i < maxLength; i++) {
    resultado?.push(grupo12[i])
    resultado?.push(grupo11[i])
  }

  const dadosAgrupados = []

  for (let i = 0; i < resultado?.length; i += 2) {
    dadosAgrupados.push({
      cod: i + 1,
      grupo: [resultado[i], resultado[i + 1] || null],
    })
  }
  return dadosAgrupados
}

export function dadosGrafico(dados, grupo) {
  if (grupo === 1) {
    return {
      labels: dados?.grupo[0]?.dados?.numero.map((_, i) => i),
      datasets: [
        {
          data: dados?.grupo[0]?.dados?.numero?.map((valor) => valor),
          backgroundColor: dados?.grupo[0]?.dados?.cor,
          borderWidth: 1,
        },
      ],
    }
  }

  if (grupo === 2) {
    return {
      labels: dados?.grupo[1]?.dados?.numero.map((_, i) => i),
      datasets: [
        {
          data: dados?.grupo[1]?.dados?.numero?.map((valor) => valor),
          backgroundColor: dados?.grupo[1]?.dados?.cor,
          borderWidth: 1,
        },
      ],
    }
  }

  return null
}

export function mostrarEsconderGraficos(esconder, selecionado, cod, todosSelecionado) {
  if (esconder) {
    if (todosSelecionado === false) {
      if (selecionado?.includes(cod)) {
        return true
      } else {
        return false
      }
    }
  }
}

export function verificarCvCoresBackground(cv) {
  if (Number(cv) < 15) {
    const cores = [
      {
        backGround1: '#2eb422',
        backGround2: '#0c8d00',
      },
    ]
    return cores
  }

  if (Number(cv) >= 15 && Number(cv) <= 20) {
    const cores = [
      {
        backGround1: '#01FF00',
        backGround2: '#01BC00',
      },
    ]
    return cores
  }

  if (Number(cv) > 20 && Number(cv) <= 25) {
    const cores = [
      {
        backGround1: '#ffff4d',
        backGround2: '#e9e900',
      },
    ]
    return cores
  }
  if (Number(cv) > 25 && Number(cv) < 30) {
    const cores = [
      {
        backGround1: '#ff954f',
        backGround2: '#ff6600',
      },
    ]
    return cores
  }
  if (Number(cv) > 30) {
    const cores = [
      {
        backGround1: '#ff3e3e',
        backGround2: '#FB0303',
      },
    ]
    return cores
  }
}

export function verificarCvCoresGraficos(cv) {
  if (Number(cv) < 15) {
    const cores = [
      {
        backGround: '#6FBE6E',
        border: '#5B9467',
        color: '#1c3b19',
      },
    ]
    return cores
  }

  if (Number(cv) >= 15 && Number(cv) <= 20) {
    const cores = [
      {
        backGround: '#E0FFC0',
        border: '#A2E66E',
        color: '#3D9412',
      },
    ]
    return cores
  }

  if (Number(cv) > 20 && Number(cv) <= 25) {
    const cores = [
      {
        backGround: '#FEFF66',
        border: '#F3C847',
        color: '#684607',
      },
    ]
    return cores
  }
  if (Number(cv) > 25 && Number(cv) <= 30) {
    const cores = [
      {
        backGround: '#FECA65',
        border: '#D49839',
        color: '#575306',
      },
    ]
    return cores
  }
  if (Number(cv) > 30) {
    const cores = [
      {
        backGround: '#FF6766',
        border: '#AC3435',
        color: '#4d0503',
      },
    ]
    return cores
  }
}

export function filtrarDadosSugestoes(dados) {
  const dadosParaSugestoes = dados.map((item) => {
    return {
      resp_calibra: item?.resp_calibra,
      precisaocalibra: item?.precisaocalibra,
      chapa: item.chapa,
      bitola: item.bitola,
      largurachapa: item.largurachapa,
      tipoesteira: item.tipoesteira,
      alinhamentoesteira: item.alinhamentoesteira,
      corrente: item.corrente,
      nivelamento: item.nivelamento,
      pqueda: item.pqueda,
      desgastepalheta: item.desgastepalheta,
      condicoesdiscos: item.condicoesdiscos,
      condicoesesteira: item.condicoesesteira,
      rpmdisco: item.rpmdisco,
      vento: item.vento,
      taxafixa: item.taxafixa,
      caixa: item.caixa,
    }
  })

  return dadosParaSugestoes[0]
}

export function criarSugestoes(medicao: PropsMedicao) {
  let dados = {
    precisaocalibra: '',
    chapa: '',
    bitola: '',
    largurachapa: '',
    tipoesteira: '',
    alinhamentoesteira: '',
    corrente: '',
    nivelamento: '',
    pqueda: '',
    desgastepalheta: '',
    condicoesdiscos: '',
    condicoesesteira: '',
    rpmdisco: '',
    vento: '',
    taxafixa: '',
    caixa: '',
  }
  const titulos = {
    precisaocalibra: 'Precisão da calibração',
    chapa: 'Chapa',
    bitola: 'Bitola',
    largurachapa: 'Largura da chapa',
    tipoesteira: 'Tipo da esteira',
    alinhamentoesteira: 'Alinhamento da esteira',
    corrente: 'Corrente',
    nivelamento: 'Nivelamento',
    pqueda: 'Ponto de queda',
    desgastepalheta: 'Desgaste da palheta',
    condicoesdiscos: 'Condições dos discos',
    condicoesesteira: 'Condições das esteiras',
    rpmdisco: 'Rpm do disco',
    vento: 'Vento',
    taxafixa: 'Taxa fixa',
    caixa: 'Caixa',
  }

  if (medicao === undefined) {
    return []
  }

  if (medicao?.resp_calibra === 'Calibrada por terceiros') {
    if (100 - Number(medicao?.precisaocalibra) >= 5) {
      dados.precisaocalibra =
        '- Calibre a máquina novamente. A precisão de calibração deve ser inferior a 5%.'
    }
  }

  if (medicao?.chapa === 'Torta (amassada)') {
    dados.chapa = '- Desentorte a chapa defletora para melhorar a distribuição.'
  } else if (medicao?.chapa === 'Sem condições de uso') {
    dados.chapa = '- Troque a chapa defletora para melhorar a distribuição.'
  } else if (medicao?.chapa === 'Ausente') {
    dados.chapa === '- Coloque uma chapa defletora nova.'
  }

  if (Number(medicao?.bitola) > Number(medicao?.largurachapa)) {
    dados.bitola =
      '- Ajuste a largura da chapa defletora para ' +
      medicao?.bitola +
      ' mm (mesma largura da bitola da máquina).'
  }

  if (medicao?.tipoesteira === 'Ferro') {
    dados.tipoesteira = '- Troque a esteira por uma de borracha.'
  }

  if (medicao?.alinhamentoesteira !== 'Alinhada') {
    dados.alinhamentoesteira = '- Alinhe a esteira.'
  }

  if (medicao?.corrente === 'Presa') {
    dados.corrente = '- Solte a corrente.'
  }

  if (medicao?.corrente === 'Sem correte') {
    dados.corrente = '- Adicionar corrente na máquina.'
  }

  if (medicao?.corrente === 'Solta') {
    dados.corrente = '- Adicionar corrente na máquina.'
  }

  if (medicao?.nivelamento !== 'Nivelada') {
    dados.nivelamento = '- Nivele o cabeçalho.'
  }

  if (medicao?.pqueda === 'Diferentes') {
    dados.pqueda = '- Iguale os pontos de queda.'
  }

  if (medicao?.desgastepalheta !== 'Novas') {
    dados.desgastepalheta = '- Troque as palhetas.'
  }

  if (medicao?.condicoesdiscos === 'Empenado') {
    dados.condicoesdiscos = '- Desempene os discos.'
  } else if (medicao?.condicoesdiscos === 'Sem condições de uso') {
    dados.condicoesdiscos = '- Troque os discos.'
  }

  if (medicao?.rpmdisco < 500 || medicao?.rpmdisco > 800) {
    dados.rpmdisco === '- Verifique e ajuste a rotação dos discos.'
  }

  if (Number(medicao?.vento) > 7) {
    dados.vento = '- Faça o teste em melhores condições (sem vento).'
  }

  if (Number(medicao.taxafixa) > 3500 && medicao?.caixa === 'Marcha 01 (doses menores de 3,5T)') {
    dados.caixa = '- Selecione Marcha 02 para a caixa de redução.'
  } else if (
    Number(medicao.taxafixa) < 3500 &&
    medicao?.caixa === 'Marcha 02 (doses maiores de 3,5T)'
  ) {
    dados.caixa = '- Selecione Marcha 01 para a caixa de redução.'
  }

  if (medicao?.condicoesesteira === 'Com vazamento') {
    dados.condicoesesteira = '- Ajuste necessário na esteira da máquina para tirar vazamento.'
  }

  if (medicao?.condicoesesteira === 'Sem condições de uso') {
    dados.condicoesesteira = '- Substitua a esteira'
  }

  const resultado = Object.keys(dados)
    .filter((key) => dados[key])
    .map((key) => ({
      titulo: titulos[key],
      descricao: dados[key],
    }))

  return resultado
}

export function dividirEmPaginasResumoSumario(dados, resumoSumario) {
  const itensPorPaginaResumo = resumoSumario === 'resumo' ? 22 : 34
  const paginas = []

  for (let i = 0; i < dados.length; i += itensPorPaginaResumo) {
    paginas.push(dados.slice(i, i + itensPorPaginaResumo))
  }
  return paginas
}

export function processarArray(dataArray) {
  const dados = dataArray === undefined ? [] : dataArray
  const sentidos11_original = dados?.filter((item) => item?.sentido === 11)
  const sentido11 = filtrarOsSentidos(dados, 11)
  const sentidos12_original = dados?.filter((item) => item?.sentido === 12)
  const sentido12 = filtrarOsSentidos(dados, 12)
  //@ts-ignore

  const resultado11 = Object?.values?.(sentido11)?.map((item, index) => {
    const keys = Object?.keys(item)
    const start = index === 0 ? 0 : index
    const end = keys?.length - (index === 0 ? 0 : index)
    const novasChaves = keys?.slice(start, end)
    const valores = novasChaves?.map((key) => item[key])
    const maior = Math.max(...Object.values(item).map(Number))
    const posicaoColuna1 = Math?.round(valores.length / 4)
    valores?.splice(posicaoColuna1, 0, `${Math.round(maior) * 2}_coluna`)
    valores?.splice(posicaoColuna1 * -1, 0, `${Math.round(maior) * 2}_coluna`)

    return valores
  })
  //@ts-ignore

  const resultado12 = Object.values(sentido12).map((item, index) => {
    const keys = Object.keys(item)
    const start = index === 0 ? 0 : index
    const end = keys.length - (index === 0 ? 0 : index)
    const novasChaves = keys.slice(start, end)
    const valores = novasChaves.map((key) => item[key])
     const maior = Math.max(...Object.values(item).map(Number))
    const posicaoColuna1 = Math.round(valores.length / 4)

    valores.splice(posicaoColuna1, 0, `${Math.round(maior) * 2}_coluna`)
    valores.splice(posicaoColuna1 * -1, 0,  `${Math.round(maior) * 2}_coluna`)
    return valores
  })
  const agruparNovosDados11 = sentidos11_original.map((item, index) => {
    return {
      cod: item?.cod,
      cv: item?.cv,
      media: item?.media,
      largura: item?.largura,
      sentido: item?.sentido,
      dados: resultado11[index],
    }
  })

  const agruparNovosDados12 = sentidos12_original.map((item, index) => {
    return {
      cod: item?.cod,
      cv: item?.cv,
      media: item?.media,
      largura: item?.largura,
      sentido: item?.sentido,
      dados: resultado12[index],
    }
  })

  const resultadoDadosTransformados = [...agruparNovosDados12, ...agruparNovosDados11]
  return resultadoDadosTransformados ?? []
}

export function filtrarOsSentidos(dados, sentido) {
  let dadosFinais = {}
  if (sentido === 11) {
    dadosFinais = dados
      ?.filter((item) => item?.sentido === 11)
      ?.map((item) => {
        return {
          r1: item?.r1,
          r2: item?.r2,
          r3: item?.r3,
          r4: item?.r4,
          r5: item?.r5,
          r6: item?.r6,
          r7: item?.r7,
          r8: item?.r8,
          r9: item?.r9,
          r10: item?.r10,
          r11: item?.r11,
          r12: item?.r12,
          r13: item?.r13,
          r14: item?.r14,
          r15: item?.r15,
          r16: item?.r16,
          r17: item?.r17,
          r18: item?.r18,
          r19: item?.r19,
          r20: item?.r20,
          r21: item?.r21,
          r22: item?.r22,
          r23: item?.r23,
          r24: item?.r24,
          r25: item?.r25,
          r26: item?.r26,
          r27: item?.r27,
          r28: item?.r28,
          r29: item?.r29,
          r30: item?.r30,
          r31: item?.r31,
          r32: item?.r32,
          r33: item?.r33,
          r34: item?.r34,
          r35: item?.r35,
          r36: item?.r36,
          r37: item?.r37,
          r38: item?.r38,
          r39: item?.r39,
          r40: item?.r40,
          r41: item?.r41,
          r42: item?.r42,
          r43: item?.r43,
          r44: item?.r44,
          r45: item?.r45,
          r46: item?.r46,
          r47: item?.r47,
          r48: item?.r48,
          r49: item?.r49,
          r50: item?.r50,
          r51: item?.r51,
          r52: item?.r52,
          r53: item?.r53,
          r54: item?.r54,
          r55: item?.r55,
          r56: item?.r56,
          r57: item?.r57,
          r58: item?.r58,
          r59: item?.r59,
          r60: item?.r60,
          r61: item?.r61,
          r62: item?.r62,
        }
      })
  }
  if (sentido === 12) {
    dadosFinais = dados
      ?.filter((item) => item?.sentido === 12)
      ?.map((item) => {
        return {
          r1: item?.r1,
          r2: item?.r2,
          r3: item?.r3,
          r4: item?.r4,
          r5: item?.r5,
          r6: item?.r6,
          r7: item?.r7,
          r8: item?.r8,
          r9: item?.r9,
          r10: item?.r10,
          r11: item?.r11,
          r12: item?.r12,
          r13: item?.r13,
          r14: item?.r14,
          r15: item?.r15,
          r16: item?.r16,
          r17: item?.r17,
          r18: item?.r18,
          r19: item?.r19,
          r20: item?.r20,
          r21: item?.r21,
          r22: item?.r22,
          r23: item?.r23,
          r24: item?.r24,
          r25: item?.r25,
          r26: item?.r26,
          r27: item?.r27,
          r28: item?.r28,
          r29: item?.r29,
          r30: item?.r30,
          r31: item?.r31,
          r32: item?.r32,
          r33: item?.r33,
          r34: item?.r34,
          r35: item?.r35,
          r36: item?.r36,
          r37: item?.r37,
          r38: item?.r38,
          r39: item?.r39,
          r40: item?.r40,
          r41: item?.r41,
          r42: item?.r42,
          r43: item?.r43,
          r44: item?.r44,
          r45: item?.r45,
          r46: item?.r46,
          r47: item?.r47,
          r48: item?.r48,
          r49: item?.r49,
          r50: item?.r50,
          r51: item?.r51,
          r52: item?.r52,
          r53: item?.r53,
          r54: item?.r54,
          r55: item?.r55,
          r56: item?.r56,
          r57: item?.r57,
          r58: item?.r58,
          r59: item?.r59,
          r60: item?.r60,
          r61: item?.r61,
          r62: item?.r62,
        }
      })
  }

  return dadosFinais
}
